import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { ToastContainer } from 'react-toastify'
import DatePicker from '../../../../../LaridaeApp/datepicker/container/DatePicker'
import { INTERVALO_CORTO } from '../../../../../../config/settings'
import { obtenerCamionesRechazadosAdmEnCalado } from '../actions/TablaCamionesRechazadosAdministrativamenteActions'
import { TablaCamionesRechazadosAdministrativamenteView } from '../components/TablaCamionesRechazadosAdministrativamenteView'

function TablaCamionesRechazadosAdministrativamente (props) {
  const { obtenerCamionesRechazadosAdmEnCalado, roles } = props

  useEffect(() => {
    const rol = roles.filter(roles => roles === 'EXPORTADOR' || roles === 'CARGADOR')
    obtenerCamionesRechazadosAdmEnCalado(new Date(), new Date(), rol)
  }, [obtenerCamionesRechazadosAdmEnCalado, roles])

  const actualizarFechas = (fechaD, fechaH) => {
    const { roles } = props
    const rol = roles.filter(roles => roles === 'EXPORTADOR' || roles === 'CARGADOR')
    props.obtenerCamionesRechazadosAdmEnCalado(fechaD, fechaH, rol)
  }

  return (
    <>
      <div className='container-entre-fechas'>
        <DatePicker
          selectRange
          locale='es'
          disabledFuture
          onDateChange={actualizarFechas}
          titulo='Seleccione las fechas'
          value='fechas'
        />
      </div>
      <TablaCamionesRechazadosAdministrativamenteView />
      <ToastContainer autoClose={INTERVALO_CORTO} />
    </>
  )
}

const mapStateToProps = state => {
  return {
    roles: state.auth.roles
  }
}

const mapActionsToProps = {
  obtenerCamionesRechazadosAdmEnCalado
}

const withRedux = connect(mapStateToProps, mapActionsToProps)
export default withRedux(TablaCamionesRechazadosAdministrativamente)
